import { useRiftArtworkPath } from '../utils/riftArtwork';
import { RiftProgressEntry as RiftProgressEntryType } from "../api";
import { RiftMarker } from "./RiftMarker";

import './RiftProgress.css';

type RiftProgressProps = {
  riftProgress: RiftProgressEntryType[];
  scale: number;
};

export const RiftProgress: React.FC<RiftProgressProps> = ({ riftProgress, scale }) => {
    return (
        <div className="rifts-container" style={{
            width: `${210 * scale}px`,
            height: `${360 * scale}px`,
            left: `${800 * scale}px`,
            top: `${260 * scale}px`
        }}>
            {riftProgress.map((rp, idx) => <RiftProgressEntry key={rp.id} riftProgressEntry={rp} idx={idx} scale={scale} />)}
        </div>
    );
};

type RiftProgressEntryProps = {
  riftProgressEntry: RiftProgressEntryType;
  idx: number;
  scale: number;
};

const RiftProgressEntry: React.FC<RiftProgressEntryProps> = ({ riftProgressEntry, idx, scale }) => {
    const artwork = useRiftArtworkPath('back');
    return (
        <div className={`rift-container rc${idx} open-${riftProgressEntry.isOpen}`}>
            <div className="rift-locations">
                <div className="rift-locations-rows">
                    <div className="rift-location rl1">
                        <RiftProgressLocation riftProgressEntry={riftProgressEntry} locationIdx={0} trackIdx={0} />
                    </div>
                    <div className="rift-location rl2">
                        <RiftProgressLocation riftProgressEntry={riftProgressEntry} locationIdx={1} trackIdx={0} />
                    </div>
                </div>
                <div className="rift-locations-rows">
                    <div className="rift-location rl3">
                        <RiftProgressLocation riftProgressEntry={riftProgressEntry} locationIdx={0} trackIdx={1} />
                    </div>
                    <div className="rift-location rl4">
                        <RiftProgressLocation riftProgressEntry={riftProgressEntry} locationIdx={1} trackIdx={1} />
                    </div>
                </div>
            </div>
            <div className="rift-marker">
                {riftProgressEntry.isOpen ? (
                    <RiftMarker
                        rift={{
                            ...riftProgressEntry,
                            turnsActive: 0,
                        }}
                        size={120 * scale}
                    />
                ) : (
                    <img className="rift-marker-image" alt='rift marker' src={artwork} />
                )}
            </div>
        </div>
    );
}

type RiftProgressLocationProps = {
  riftProgressEntry: RiftProgressEntryType;
  trackIdx: number;
  locationIdx: number;
};

const RiftProgressLocation: React.FC<RiftProgressLocationProps> = ({ riftProgressEntry, trackIdx, locationIdx }) => {
    const location = (riftProgressEntry.tracks[trackIdx].locations || [])[locationIdx];

    if (!location) {
        return null;
    }

    return <img className={`progress-marker ${location}`} alt='rift progress marker' src={`/rifts/${location}.png`} />;
}
